export const DEFAULT_TECH_DATA_FIELDS = [
  'SerialNumber',
  'OwnerCode',
  'UOM',
  'Source',
  'TraceNumber',
  'TagAgency',
  'TagDate',
];

export const TECH_DATA_FIELD_DEFS = [
  { key: 'Description', label: 'Description', always: true },
  { key: 'Quantity', label: 'Qty Available' },
  { key: 'UOM', label: 'Unit of Measure' },
  { key: 'Price', label: 'Price', fmt: 'price' },
  { key: 'WarehouseName', label: 'Warehouse' },
  { key: 'LocationName', label: 'Location' },
  { key: 'SerialNumber', label: 'Serial #' },
  { key: 'OwnerCode', label: 'Owner Code' },
  { key: 'Source', label: 'Source' },
  { key: 'TagNumber', label: 'Tag #' },
  { key: 'TraceNumber', label: 'Trace #' },
  { key: 'TagAgency', label: 'Tag Agency' },
  { key: 'TagDate', label: 'Tag Date' },
  { key: 'TSO', label: 'Time Since Overhaul' },
  { key: 'Notes', label: 'Notes' },
];

export function resolveTechDataFields(keys) {
  if (Array.isArray(keys) && keys.length > 0) return keys;
  return DEFAULT_TECH_DATA_FIELDS;
}
